import React, { useState } from "react";
import { contactContent } from "@/mock/siteContent";
import { toast } from "@/components/ui/sonner";

const initialForm = { name: "", email: "", message: "" };

const Contact = () => {
  const [form, setForm] = useState(initialForm);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) { toast.error("Preencha todos os campos."); return; }
    setSubmitting(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error("Erro ao enviar");
      toast.success("Mensagem enviada com sucesso!");
      setForm(initialForm);
    } catch {
      toast.error("Erro ao enviar mensagem. Tente novamente.");
    } finally {
      setSubmitting(false);
    }
  };

  const labelStyle = { fontFamily: "'DM Mono', monospace", fontSize: "0.62rem", letterSpacing: "0.18em", color: "var(--muted2)", textTransform: "uppercase", display: "block", marginBottom: 6 };

  return (
    <div>
      <section data-testid="contact-header" style={{ borderBottom: "1px solid var(--border)", padding: "64px 24px 48px", maxWidth: 1140, margin: "0 auto" }}>
        <p style={{ fontFamily: "'DM Mono', monospace", fontSize: "0.62rem", letterSpacing: "0.2em", color: "var(--gold)", textTransform: "uppercase", marginBottom: 14, display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ width: 20, height: 1, background: "var(--gold)", display: "inline-block" }} />
          Contato
        </p>
        <h1 data-testid="contact-title" style={{ fontFamily: "'Syne', sans-serif", fontWeight: 600, fontSize: "clamp(1.8rem, 3.5vw, 2.6rem)", color: "var(--text)", letterSpacing: "-0.01em" }}>
          Fale com a BIMtec
        </h1>
      </section>
      <section data-testid="contact-content" className="grid-contact" style={{ maxWidth: 1140, margin: "0 auto", padding: "64px 24px", display: "grid", gridTemplateColumns: "minmax(0,1fr) minmax(0,1.2fr)", gap: 64, alignItems: "start" }}>
        <div>
          <p style={{ fontSize: "0.9rem", color: "var(--muted)", lineHeight: 1.75, marginBottom: 40 }}>{contactContent.intro}</p>
          <p style={{ fontSize: "0.875rem", color: "var(--muted)", lineHeight: 1.7, marginBottom: 40 }}>Ao entrar em contato você fala com engenheiros que atuam no dia a dia com coordenação e modelagem BIM — não com atendimento genérico.</p>
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            {[
              { label: "E-mail", value: contactContent.email, href: `mailto:${contactContent.email}` },
              { label: "WhatsApp", value: "+55 (94) 99114-6693", href: "https://wa.me/5594991146693?text=Ol%C3%A1%2C%20tenho%20interesse%20em%20projetos%20BIM%20e%20gostaria%20de%20falar%20com%20um%20especialista%20para%20tirar%20algumas%20d%C3%BAvidas" },
            ].map(({ label, value, href }) => (
              <div key={label} style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                <span style={{ fontFamily: "'DM Mono', monospace", fontSize: "0.6rem", letterSpacing: "0.18em", color: "var(--muted2)", textTransform: "uppercase" }}>{label}</span>
                <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer"
                  data-testid={`contact-${label.toLowerCase().replace("-", "")}-link`}
                  style={{ fontFamily: "'Syne', sans-serif", fontWeight: 600, fontSize: "0.9rem", color: "var(--gold)", textDecoration: "none", transition: "opacity 0.2s" }}
                  onMouseEnter={e => e.currentTarget.style.opacity = "0.75"}
                  onMouseLeave={e => e.currentTarget.style.opacity = "1"}
                >{value}</a>
              </div>
            ))}
            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
              <span style={{ fontFamily: "'DM Mono', monospace", fontSize: "0.6rem", letterSpacing: "0.18em", color: "var(--muted2)", textTransform: "uppercase" }}>Localização</span>
              <span style={{ fontFamily: "'Syne', sans-serif", fontWeight: 600, fontSize: "0.9rem", color: "var(--muted)" }}>Canaã dos Carajás, PA — Brasil</span>
            </div>
          </div>
        </div>
        <div style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 8, overflow: "hidden" }}>
          <div style={{ padding: "16px 24px", borderBottom: "1px solid var(--border)", display: "flex", alignItems: "center", gap: 8 }}>
            {["#ef4444","#f59e0b","#22c55e"].map((c) => (<span key={c} style={{ width: 8, height: 8, borderRadius: "50%", background: c, opacity: 0.7 }} />))}
            <span style={{ fontFamily: "'DM Mono', monospace", fontSize: "0.6rem", letterSpacing: "0.14em", color: "var(--muted2)", marginLeft: 8, textTransform: "uppercase" }}>enviar mensagem</span>
          </div>
          <form data-testid="contact-form" onSubmit={handleSubmit} style={{ padding: "28px 24px", display: "flex", flexDirection: "column", gap: 20 }}>
            {[
              { id: "name", label: "Nome", type: "text", placeholder: "Como devemos te chamar?" },
              { id: "email", label: "E-mail", type: "email", placeholder: "Seu e-mail para retorno" },
            ].map(({ id, label, type, placeholder }) => (
              <div key={id}>
                <label htmlFor={id} style={labelStyle}>{label}</label>
                <input id={id} name={id} type={type} value={form[id]} onChange={handleChange} placeholder={placeholder} className="cb-input" data-testid={`contact-input-${id}`} />
              </div>
            ))}
            <div>
              <label htmlFor="message" style={labelStyle}>Mensagem</label>
              <textarea id="message" name="message" rows={5} value={form.message} onChange={handleChange} placeholder="Conte sobre o projeto, escopo ou necessidade em BIM." className="cb-input" data-testid="contact-input-message" />
            </div>
            <p style={{ fontFamily: "'DM Mono', monospace", fontSize: "0.6rem", color: "var(--muted2)", letterSpacing: "0.06em", lineHeight: 1.6 }}>
              * Sua mensagem será enviada diretamente para nossa equipe.
            </p>
            <button type="submit" className="btn-gold" data-testid="contact-submit-button" disabled={submitting} style={{ width: "100%", justifyContent: "center", opacity: submitting ? 0.7 : 1 }}>
              {submitting ? "Enviando..." : "Enviar mensagem"}
              {!submitting && (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>)}
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default Contact;
